import React from "react";
import moment from "moment";
import editIcon from "../../../../assets/edit_icon_vacations.svg";
import deleteIcon from "../../../../assets/deleteIcon.svg";

const SlotTimeList = ({
  start_date,
  end_date,
  editVacation,
  handleDeleteVacation,
}) => {
  return (
    <div className="slot-time-list">
      <div className="slot-time-list-picker">
        <div className="slot-time-list-picker-start-date">
          {moment(start_date).format("DD/MM/YYYY")}
        </div>
        <div className="connector">to</div>
        <div className="slot-time-list-picker-end-date">
          {moment(end_date).format("DD/MM/YYYY")}
        </div>
      </div>
      <div className="slot-time-list-icons">
        <div className="slot-time-list-icons-img">
          <img src={editIcon} onClick={editVacation} />
        </div>
        <div className="slot-time-list-icons-img">
          <img src={deleteIcon} onClick={handleDeleteVacation} />
        </div>
      </div>
    </div>
  );
};

export default SlotTimeList;
